import { useGtmTrack } from '../composables/use-gtm-track'

export default defineNuxtPlugin(nuxt => {
  const config = useRuntimeConfig()
  const { isPreview } = useBaseRoutes()
  const { createGtm, getGtmDataLayerVariableVersion2, trackEvent } =
    useGtmTrack()

  nuxt.vueApp.use(
    createGtm({
      id: config.public.gtm.id || 'GTM-N72VQC',
      defer: true,
      compatibility: false,
      enabled: config.public.gtm.enabled && !isPreview.value,
      loadScript: true,
      trackOnNextTick: false,
    })
  )

  addRouteMiddleware(
    'gtm-router-middleware',
    async to => {
      const pageUrl = useRequestURL().origin + to.fullPath
      const { currentUser } = await useCurrentUser()
      const variableVersion2 = getGtmDataLayerVariableVersion2(
        currentUser.value
      )

      trackEvent({
        event: 'page_viewed',
        pageUrl,
        ...variableVersion2,
      })
    },
    { global: true }
  )
})
